import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { alertInfo } from 'services/alerts';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

// Constants
import { ROLES } from 'services/constants';

// Style
import * as s from './styles';

const allNavigationList = [
  { translateKey: 'dashboard', disabled: true },
  {
    translateKey: 'appointments',
    selectList: [
      { translateKey: 'today', pathname: '/practitioner/appointments/today' },
      { translateKey: 'planning', pathname: '/practitioner/appointments/planning' },
      // { translateKey: 'canceling', pathname: '/practitioner/appointments/canceling' }, ONLY FOR MONICA!!!
      { translateKey: 'actions', pathname: '/practitioner/jobs' },
    ],
  },
  { translateKey: 'reporting', pathname: '/practitioner/reporting' },
  { translateKey: 'settings', disabled: true },
];

const navigationByRole = () => {
  const role = localStorage.getItem('um_role');
  if (role === ROLES.RADIOLOGY) {
    const tempArr = allNavigationList.map((el) => el);
    tempArr.splice(2, 1); // delete reporting page
    return tempArr;
  }
  return allNavigationList;
};


class PractitionerNavigation extends Component {
  constructor(props) {
    super(props);
    this.navigationList = navigationByRole();
    this.state = { value: this.navigationList[1] };
    this.handleClickNavigationItem = this.handleClickNavigationItem.bind(this);
    this.renderDropdownSelect = this.renderDropdownSelect.bind(this);
    this.setActiveValue = this.setActiveValue.bind(this);
    this.showAlertInfo = this.showAlertInfo.bind(this);

    this.historyListen = this.props.history.listen((location) => {
      this.setActiveValue(location.pathname);
    });
  }

  componentDidMount() {
    const { history: { location: { pathname } } } = this.props;
    this.setActiveValue(pathname);
  }

  componentWillUnmount() {
    this.historyListen();
  }

  setActiveValue(pathname) {
    if (this.navigationList && this.navigationList) {
      this.navigationList.forEach((item) => {
        const slList = item.selectList;
        if (pathname.indexOf(item.pathname) > -1 || (slList && slList.find((el) => pathname.indexOf(el.pathname) > -1))) {
          this.setState({ value: item });
        }
      });
    }
  }

  isActive(stringKey) {
    const { value: { translateKey } } = this.state;
    return stringKey && translateKey && stringKey === translateKey;
  }

  handleClickNavigationItem(item) {
    const { history } = this.props;
    if (item && history) {
      if (!item.selectList && item.pathname && !item.disabled) {
        this.setState({ value: item }, () => {
          history.push(item.pathname);
        });
      } else if (!item.selectList && !item.pathname && !item.disabled) {
        this.showAlertInfo();
      }
    }
  }

  showAlertInfo() {
    alertInfo(this.props.t('snack_bar_not_ready_feature'));
  }

  renderDropdownSelect(itemRow) {
    const { t, history } = this.props;
    if (itemRow && t && history) {
      return (
        <s.NavigationSelect
          data={itemRow.selectList}
          itemComponent={({ item }) => <span>{t(item.translateKey)}</span>}
          defaultValue={itemRow.selectList.find((i) => i.pathname === window.location.pathname)}
          valueComponent={() => <span>{t(itemRow.translateKey)}</span>}
          onChange={(e) => {
            if (e.pathname) {
              this.setState({ value: itemRow }, () => {
                history.push(e.pathname);
              });
            } else {
              this.showAlertInfo();
            }
          }}
        />
      );
    }
    return null;
  }

  render() {
    const { t } = this.props;

    return (
      <s.Navigation>
        {this.navigationList.map((item) => (
          <s.NavigationItem
            key={`header-navigation-${item.translateKey}`}
            disabled={item.disabled}
            isActive={this.isActive(item.translateKey)}
            onClick={() => { this.handleClickNavigationItem(item); }}
          >

            {/* ──── Drop down ───────────────────────────────────────────────────────────────────── */}
            {item.selectList ? this.renderDropdownSelect(item) : t(item.translateKey)}

          </s.NavigationItem>
        ))}
      </s.Navigation>
    );
  }
}
PractitionerNavigation.propTypes = {
  history: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(withRouter(PractitionerNavigation));
